import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as SimulatorActions from '../../actions/Simulator.js';

// Icons
import water from '../../static/images/water-icon.png';
import tree from '../../static/images/tree-icon.png';
import dog from '../../static/images/dog-icon.png';
import phone from '../../static/images/phone-icon.png';
import bird from '../../static/images/bird-icon.png';
import plane from '../../static/images/plane-icon.png';
import bus from '../../static/images/bus-icon.png';

const POINT_SIZE = 8;
const BOX_SIZE = 16;
const BOX_OFFSET = BOX_SIZE / 2;
const BOARD_OFFSET_LEFT = 40;
const BOARD_HORIZONTAL_BLOCK_SIZE = POINT_SIZE + 1;
const BOARD_VERTICAL_BLOCK_SIZE = 14;
const yAix = ['0', '20', '40', '60', '80', '100', '120'];
const xAix = ['125', '250', '300', '500', '1k', '2k', '4k', '8k'];
const icons = [
  { iconName: 'water', x: 2, y: 3 },
  { iconName: 'tree', x: 5, y: 2 },
  { iconName: 'bird', x: 8, y: 4 },
  { iconName: 'phone', x: 6, y: 6 },
  { iconName: 'dog', x: 3, y: 7 },
  { iconName: 'bus', x: 1, y: 11 },
  { iconName: 'plane', x: 7, y: 13 },
];

const styles = {
  container: {
    width: 870,
    margin: '0 auto',
  },
  canvas: {
    cursor: 'pointer',
    boxSizing: 'border-box',
    '@meida (max-width: 1024px)': {
      padding: '12px',
    },
  },
  icon: {
    display: 'none',
  },
  footerWrap: {
    width: '100%',
  },
  title: {
    color: '#A39671',
    letterSpacing: 2.5,
    fontSize: 20,
    display: 'block',
    margin: '10px 0',
  },
  text: {
    fontSize: 17,
    color: 'white',
    display: 'block',
    margin: '5px 0px',
    letterSpacing: 1.5
  },
  buttonWrap: {
    textAlign: 'center',
    margin: '12px 0 0 0',
  },
  button: {
    width: 260,
    lineHeight: '42px',
    outline: 'none',
    padding: 0,
    border: 0,
    borderRadius: 3,
    cursor: 'pointer',
    backgroundColor: '#FED312',
    color: 'white',
    letterSpacing: 4,
    fontSize: 15
  },
};

class SimulatorLeftEar extends Component {
  constructor(props) {
    super(props);

    this.drawing = true;

    this.state = {
      points: [],
      targetIndex: null,
      isDown: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      blockW: 0,
      blockH: 0,
    };

    this.resizeListener = () => this.onWindowResize();
  }

  componentDidMount() {
    this.canvas = document.getElementById('canvas');
    this.ctx = this.canvas.getContext('2d');

    window.addEventListener('resize', this.resizeListener);
    this.onWindowResize();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.points.length && this.state.points.length) {
      this.draw();
    }
  }

  componentWillUnmount() {
    this.drawing = false;

    window.removeEventListener('resize', this.resizeListener);
  }

  onWindowResize() {
    const windowWidth = document.body.clientWidth > 1200 ? 1200 : document.body.clientWidth;
    const windowHeight = document.body.clientHeight > 800 ? 800 : document.body.clientHeight;
    let height = (windowHeight - 330) - ((windowHeight - 330) % BOARD_VERTICAL_BLOCK_SIZE);

    let width = windowWidth - 398 - ((windowWidth - 398) % BOARD_HORIZONTAL_BLOCK_SIZE);

    if (windowWidth <= 1024) {
      width = windowWidth - 138 - ((windowWidth - 138) % BOARD_HORIZONTAL_BLOCK_SIZE);
      height = (windowHeight - 430) - ((windowHeight - 430) % BOARD_VERTICAL_BLOCK_SIZE);
    }

    const blockW = width / BOARD_HORIZONTAL_BLOCK_SIZE;
    const blockH = height / BOARD_VERTICAL_BLOCK_SIZE;
    // Make points
    const points = Array.apply(null, { length: POINT_SIZE }).map((n, idx) => ({
      x: BOARD_OFFSET_LEFT + blockW * (idx + 1),
      y: blockH,
    }));

    this.setState({
      points,
      blockW,
      blockH,
    });
  }

  drawBoard() {
    const {
      blockW,
      blockH,
    } = this.state;

    const {
      width,
      height,
    } = this.canvas;

    this.ctx.strokeStyle = '#9B9B9B';
    this.ctx.clearRect(0, 0, width, height);
    this.ctx.beginPath();
    this.ctx.lineWidth = 1;

    // horizontal
    const horizontalEnd = blockW * BOARD_HORIZONTAL_BLOCK_SIZE;
    Array.apply(null, { length: BOARD_VERTICAL_BLOCK_SIZE + 1 }).forEach((n, idx) => {
      this.ctx.moveTo(BOARD_OFFSET_LEFT, blockH * idx);
      this.ctx.lineTo(BOARD_OFFSET_LEFT + horizontalEnd, blockH * idx);
      this.ctx.stroke();
    });

    // vertical
    const verticalEnd = blockH * BOARD_VERTICAL_BLOCK_SIZE;
    Array.apply(null, { length: BOARD_HORIZONTAL_BLOCK_SIZE + 1 }).forEach((n, idx) => {
      this.ctx.moveTo(BOARD_OFFSET_LEFT + (blockW * idx), 0);
      this.ctx.lineTo(BOARD_OFFSET_LEFT + (blockW * idx), verticalEnd);
      this.ctx.stroke();
    });

    // y-aix
    this.ctx.fillStyle = 'white';
    this.ctx.lineWidth = 3;
    this.ctx.fillText('dB HL', 35, 10);
    this.ctx.textAlign = 'right';
    yAix.forEach((n, idx) => {
      this.ctx.fillText(n, 20, blockH * idx * 2 + blockH + 5);
    });
    // x-aix
    this.ctx.fillStyle = 'white';
    this.ctx.lineWidth = 3;
    this.ctx.textAlign = 'right';
    xAix.forEach((n, idx) => {
      this.ctx.fillText(n, blockW * idx + blockW + BOARD_OFFSET_LEFT + 8, blockH * BOARD_VERTICAL_BLOCK_SIZE + 20);
    });

    // icons
    icons.forEach((icon) => {
      const image = document.getElementById(icon.iconName);
      const imageSize = blockW * 0.8;
      this.ctx.drawImage(
        image,
        BOARD_OFFSET_LEFT + icon.x * blockW - (imageSize / 2),
        icon.y * blockH - (imageSize / 2),
        imageSize,
        imageSize,
      );
    });

    this.ctx.fillText(
      'Hz',
      blockW * BOARD_HORIZONTAL_BLOCK_SIZE + BOARD_OFFSET_LEFT + 8,
      blockH * BOARD_VERTICAL_BLOCK_SIZE + 20
    );
  }

  draw() {
    const {
      blockW,
      blockH,
      points,
    } = this.state;

    this.drawBoard();

    // Draw connectors
    this.ctx.beginPath();
    this.ctx.lineWidth = 1;
    this.ctx.strokeStyle = '#5CBDE7';
    this.ctx.fillStyle = 'rgba(92, 189, 231, 0.3)';
    this.ctx.moveTo(BOARD_OFFSET_LEFT + blockW, blockH);

    points.forEach((point) => {
      this.ctx.lineTo(point.x, point.y);
    });

    this.ctx.lineTo(BOARD_OFFSET_LEFT + blockW * (BOARD_HORIZONTAL_BLOCK_SIZE - 1), blockH);
    this.ctx.lineTo(BOARD_OFFSET_LEFT + blockW, blockH);
    this.ctx.stroke();
    this.ctx.fill();

    // Draw times
    this.ctx.strokeStyle = '#5CBDE7';
    this.ctx.lineWidth = 3;

    points.forEach((point) => {
      this.ctx.beginPath();
      this.ctx.moveTo(point.x - BOX_OFFSET, point.y - BOX_OFFSET);
      this.ctx.lineTo(point.x + BOX_OFFSET, point.y + BOX_OFFSET);
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.moveTo(point.x + BOX_OFFSET, point.y - BOX_OFFSET);
      this.ctx.lineTo(point.x - BOX_OFFSET, point.y + BOX_OFFSET);
      this.ctx.stroke();
    });

    if (this.drawing) requestAnimationFrame(() => this.draw());
  }

  clickTimes(x, y) {
    const windowWidth = document.body.clientWidth;
    let touchRange = 50;

    if (windowWidth <= 767) {
      touchRange = 10;
    }
    const targetIndex = this.state.points.findIndex((box) => (
      Math.sqrt((x - box.x) * (x - box.x) + (y - box.y) * (y - box.y)) < touchRange
    ));

    if (targetIndex === -1) return false;
    this.setState({
      targetIndex,
    });

    return true;
  }

  handleMouseDown(e) {
    const canvas = document.getElementById('canvas');
    const offsetX = canvas.offsetLeft;
    const offsetY = canvas.offsetTop;

    const startX = e.clientX - offsetX;
    const startY = e.clientY - offsetY;

    this.setState({
      startX,
      startY,
      isDown: this.clickTimes(startX, startY),
      offsetX,
      offsetY,
    });
  }

  handleMouseUp() {
    this.setState({
      targetIndex: null,
      isDown: false,
    });
  }

  handleMouseOut() {
    this.handleMouseUp();
  }

  handleMouseMove(e) {
    const {
      isDown,
      offsetY,
      startY,
      points,
      targetIndex,
    } = this.state;

    if (!isDown) return null;

    const mouseY = e.clientY - offsetY;
    const dy = mouseY - startY;

    this.setState({
      startY: mouseY,
      points: [
        ...points.slice(0, targetIndex),
        Object.assign({}, points[targetIndex], {
          y: points[targetIndex].y + dy,
        }),
        ...points.slice(targetIndex + 1),
      ],
    });

    return true;
  }

  submit() {
    const {
      submitLeftEar,
    } = this.props;

    const {
      blockH,
      points,
    } = this.state;

    // points normalization
    const result = points.map((point) => (
      Math.round(((point.y - blockH) / blockH) * 10)
    ));

    submitLeftEar(result);
  }

  render() {
    const windowWidth = document.body.clientWidth > 1200 ? 1200 : document.body.clientWidth;
    const windowHeight = document.body.clientHeight > 800 ? 800 : document.body.clientHeight;
    let height = windowHeight - 300;

    let width = windowWidth - 348;

    if (windowWidth <= 1024) {
      width = windowWidth - 88 - ((windowWidth - 88) % BOARD_HORIZONTAL_BLOCK_SIZE);
      height = windowHeight - 400;
    }

    return (
      <div style={styles.wrap}>
        <div style={styles.container}>
          <canvas
            id="canvas"
            style={styles.canvas}
            width={width}
            height={height}
            onTouchMove={(e) => this.handleMouseMove(e.changedTouches[0])}
            onTouchStart={(e) => this.handleMouseDown(e.changedTouches[0])}
            onTouchEnd={(e) => this.handleMouseOut(e.changedTouches[0])}
            onMouseMove={(e) => this.handleMouseMove(e)}
            onMouseUp={(e) => this.handleMouseUp(e)}
            onMouseDown={(e) => this.handleMouseDown(e)}
            onMouseOut={(e) => this.handleMouseOut(e)}>
          </canvas>
        </div>
        <div style={styles.footerWrap}>
          <span style={styles.title}>設定左耳音場：</span>
          <span style={styles.text}>向下拉動每個叉叉至適當位置以設定左耳音場。</span>
          <div style={styles.buttonWrap}>
            <button type="button" style={styles.button} onClick={() => this.submit()}>下一步</button>
          </div>
        </div>
        <div style={styles.icon}>
          <img id="water" src={water} role="presentation" />
          <img id="tree" src={tree} role="presentation" />
          <img id="dog" src={dog} role="presentation" />
          <img id="phone" src={phone} role="presentation" />
          <img id="plane" src={plane} role="presentation" />
          <img id="bird" src={bird} role="presentation" />
          <img id="bus" src={bus} role="presentation" />
        </div>
      </div>
    );
  }
}

SimulatorLeftEar.propTypes = {
  submitLeftEar: T.func,
};

export default connect(
  () => ({

  }),
  dispatch => bindActionCreators(SimulatorActions, dispatch),
)(radium(SimulatorLeftEar));



// WEBPACK FOOTER //
// ./containers/Simulators/SimulatorLeftEar.js